import { useState } from "react";
import { useLocation } from "react-router-dom";

import SaveDataButton from "../../data-table-custom/save-data-button";
import DeleteDataButton from "../../data-table-custom/delete-button";

export default function SensorTypeEdit() {
	const { state } = useLocation();

	const [nome, setNome] = useState(`${state.sensorTypeData.nome}`);

	return (
		<div className="page">
			<div className="admin-container">
				<span className="admin-title">ID</span>
				<input
					className="admin-input-disabled"
					type="text"
					name="id"
					value={`${state.sensorTypeData.id}`}
					readOnly
				/>
			</div>
			<div className="admin-container">
				<span className="admin-title">Nome</span>
				<input
					className="admin-input"
					type="text"
					name="nome"
					value={nome}
					onChange={(e) => setNome(e.target.value)}
				/>
			</div>
			<div className="footer">
				<SaveDataButton
					data={{
						id: `${state.sensorTypeData.id}`,
						nome: `${nome}`,
					}}
					action={"put"}
					endpoint={`/tipo_sensor_api/${state.sensorTypeData.id}`}
					returnTo={"/sensor-type"}
				/>
				<DeleteDataButton
					endpoint={`/tipo_sensor_api/${state.sensorTypeData.id}`}
					returnTo={"/sensor-type"}
				/>
			</div>
		</div>
	);
}
